import { Link } from 'react-router-dom';
import { PageContainer } from '@/components/layout/PageContainer';
import { ActionButton } from '@/components/ui/ActionButton';

export default function NotFoundPage() {
  return (
    <PageContainer>
      <div className="flex flex-col items-center justify-center gap-16 py-64 text-center">
        <p className="text-xs font-semibold uppercase tracking-wide text-primary-600">404</p>
        <h1 className="text-3xl font-semibold text-neutral-900">Page not found</h1>
        <p className="max-w-md text-base text-neutral-600">
          The page you tried to open doesn't exist or you don't have access to it.
        </p>
        <Link to="/">
          <ActionButton variant="primary">Back to dashboard</ActionButton>
        </Link>
      </div>
    </PageContainer>
  );
}
